module.exports = __webpack_public_path__ + "img/2_120.603d4e8f.png";